import { render } from "./EquiposMarcasPage.vue?vue&type=template&id=3a0cf160"
import script from "./EquiposMarcasPage.vue?vue&type=script&lang=js"
export * from "./EquiposMarcasPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__